import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-criminal-event-view',
  templateUrl: './new-criminal-event-view.component.html',
  styleUrls: ['./new-criminal-event-view.component.css']
})
export class NewCriminalEventViewComponent implements OnInit {
  title="Criminal Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/criminal-events/new-criminal-event-view/new-criminal-event-view.component.ts